export const events = {
  viewRequests: 'View requests',
  viewEmployees: 'View employees',
  viewSummary: 'View summary',
  viewSettings: 'View settings',
  employeesOpenMissingInfoSidepanel: 'Open missing info sidepanel',
  employeesClickMissingInfoLink: 'Click missing info link',
  employeesToggleStatusSubmit: 'Toggle employee status submit',
  employeesToggleStatusResult: 'Toggle employee status result',
  summaryExportOpened: 'Export opened',
  settingsSaveResult: 'Settings save result',
}
